import { styled } from 'linaria/react';
import { breakpoints } from 'media';

export const BestSellersContainer = styled.div`
	width: 100%;
	display: grid;
	grid-auto-rows: 355px;
	grid-template-columns: repeat(4, 1fr);
	margin-top: 32px;
	margin-bottom: 32px;
	column-gap: 32px;
	row-gap: 24px;
	${breakpoints.to.desktop} {
		grid-template-columns: repeat(6, 1fr);
		column-gap: 12px;
	}

	${breakpoints.to.tablet} {
		grid-auto-rows: auto;
		grid-template-columns: 1fr;
		margin-top: 24px;
		column-gap: 0;
		row-gap: 20px;
		margin-bottom: 0px;
	}
`;

export const TitleWrapper = styled.div`
	margin: 32px 0px;
`;
